import { RouteConfig } from 'vue-router'

export const testRoute: RouteConfig = {
  path: '/test',
  name: 'test',
  component: () => import('../views/Test.vue'),
}

export const testSosoRoute: RouteConfig = {
  path: '/test-soso',
  name: 'test-soso',
  component: () => import('../views/TestSoso.vue'),
  meta: {
    ignoreLogin: true,
  },
}

export const testKdUiRoute: RouteConfig = {
  path: '/test-kd-ui',
  name: 'test-kd-ui',
  component: () => import('../views/TestKdUi.vue'),
}

export const testVue3Route: RouteConfig = {
  path: '/test-vue-3',
  name: 'test-vue-3',
  component: () => import('../views/TestVue3.vue'),
}

export const demoSoSoV2: RouteConfig = {
  path: '/demo/sosov2',
  name: 'demo_sosov2',
  component: () => import('../views/demo/sosov2/Index.vue'),
  meta: {
    ignoreLogin: true,
  },
}

export const demoSoSoGame: RouteConfig = {
  path: '/demo/sosogame',
  name: 'demo_soso_game',
  component: () => import('../views/demo/sosov2/Game.vue'),
  meta: {
    ignoreLogin: true,
  },
}

export const demoSoSoCc: RouteConfig = {
  path: '/demo/sosocc',
  name: 'demo_sosocc',
  component: () => import('../views/demo/sosocc/Index.vue'),
  meta: {
    ignoreLogin: true,
  },
}

export const demoWakeupRoute: RouteConfig = {
  path: '/demo/wakeup',
  name: 'demo_wakeup',
  component: () => import('../views/demo/wakeup/Index.vue'),
  meta: {
    ignoreLogin: true,
  },
}

export const demoNfcRoute: RouteConfig = {
  path: '/demo/nfc',
  name: 'demo_nfc',
  component: () => import('../views/demo/nfc/Index.vue'),
  meta: {
    ignoreLogin: true,
  },
}

export const demoVolcRtcPush: RouteConfig = {
  path: '/demo/volcrtc/push',
  name: 'demo_volcrtc_push',
  component: () => import('../views/demo/volcrtc/LivePush.vue'),
  meta: {
    ignoreLogin: true,
  },
}

export const demoVolcRtcPlay: RouteConfig = {
  path: '/demo/volcrtc/play',
  name: 'demo_volcrtc_play',
  component: () => import('../views/demo/volcrtc/LivePlay.vue'),
  meta: {
    ignoreLogin: true,
  },
}

export const demoVolcRtcClassMatchPush: RouteConfig = {
  path: '/demo/volcrtc/class-match-push',
  name: 'demo_volcrtc_class_match_push',
  component: () => import('../views/demo/volcrtc/ClassMatchPush.vue'),
  meta: {
    ignoreLogin: true,
  },
}

export default [
  testRoute,
  testSosoRoute,
  testKdUiRoute,
  testVue3Route,
  demoSoSoV2,
  demoSoSoCc,
  demoSoSoGame,
  demoWakeupRoute,
  demoNfcRoute,
  demoVolcRtcPush,
  demoVolcRtcPlay,
  demoVolcRtcClassMatchPush,
]
